var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import FaqAnswer from './FaqAnswer';
import FaqQuestion from './FaqQuestion';
var FaqWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: grid;\n  background-color: #f7f6f6;\n  border: 1px solid #cfd8dc;\n  border-left-width: 0px;\n  border-right-width: 0px;\n  border-bottom-width: 0px;\n  border-top-width: 0px;\n  border-bottom-color: #cfd8dc;\n  max-width: 700px;\n"])));
FaqWrapper.displayName = 'FaqWrapper';

var Faq = function Faq(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(FaqWrapper, {
    className: className
  }, children);
};

Faq.propTypes = {
  /**
    Required and consists of everything between opening and closing tags
   */
  children: PropTypes.node.isRequired,

  /**
   Optional className to include in rendered component
  */
  className: PropTypes.string
};
Faq.Question = FaqQuestion;
Faq.Answer = FaqAnswer;
Faq.Question.displayName = Faq.Question;
Faq.Answer.displayName = Faq.Answer;
export default Faq;